import { breaking } from "@utils/console";

export default {
  name: "bootable",

  props: {
    eager: Boolean
  },

  data: () => ({
    isBooted: false
  }),

  computed: {
    hasContent() {
      return this.isBooted || this.eager || this.isActive;
    }
  },

  watch: {
    isActive() {
      this.isBooted = true;
    }
  },

  created() {
    if ("lazy" in this.$attrs) {
      breaking("lazy", "eager", this);
    }
  },

  methods: {
    showLazyContent(content) {
      return this.hasContent ? content : undefined;
    }
  }
};
